import { render, staticRenderFns } from "./reservation_change.vue?vue&type=template&id=1856a679&scoped=true&"
import script from "./reservation_change.vue?vue&type=script&lang=js&"
export * from "./reservation_change.vue?vue&type=script&lang=js&"
import style0 from "./reservation_change.vue?vue&type=style&index=0&id=1856a679&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1856a679",
  null
  
)

export default component.exports